import React from 'react';
import { Info } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  title: string;
  subtitle?: string;
  showAdSpace?: boolean;
  className?: string;
  actionLabel?: string;
  onAction?: () => void;
  showIcon?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  subtitle,
  className = '',
  actionLabel,
  onAction,
  showIcon = true,
}) => {
  return (
    <div
      data-test-id="empty-state"
      className={`flex flex-col items-center justify-center py-12 px-6 text-center ${className}`}
    >
      {showIcon && (
        <div className="mb-4">
          <Info data-test-id="empty-state-icon" className="w-12 h-12 text-text-muted" />
        </div>
      )}

      <h3 data-test-id="empty-state-title" className="text-text-primary font-medium mb-2">
        {title}
      </h3>

      {subtitle && (
        <p data-test-id="empty-state-subtitle" className="text-text-secondary text-sm mb-6">
          {subtitle}
        </p>
      )}

      {actionLabel && onAction && (
        <Button
          data-test-id="empty-state-action"
          variant="secondary"
          onClick={onAction}
          className="mt-4 bg-[#2A2A2A] hover:bg-[#353535] text-white"
        >
          {actionLabel}
        </Button>
      )}

      {/* {showAdSpace && (
        <div data-test-id="ad-space" className="mt-8">
          <div className="bg-app-surface rounded-lg px-6 py-3 border border-border/20">
            <span className="text-text-muted text-sm">Ad Space</span>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default EmptyState;
